import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getClubs = async () => {
  const { data } = await axios(`${API_URL}/club`);
  return data;
};
